// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionActionName, PermissionActionNameSchema } from 'api/gen/PermissionActionName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionCode, PermissionCodeSchema } from 'api/gen/PermissionCode';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionControllerName, PermissionControllerNameSchema } from 'api/gen/PermissionControllerName';

const requiredPart = t.interface({
  actionName: t.union([PermissionActionNameSchema, t.null]),
  code: t.union([PermissionCodeSchema, t.null]),
  controllerName: t.union([PermissionControllerNameSchema, t.null]),
});

export const ValidatePermissionSchema = excess(requiredPart);

export interface ValidatePermission extends t.TypeOf<typeof ValidatePermissionSchema> {}
